import { Component, OnInit } from '@angular/core';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../core/navigation.service';
import { LeftPanelService } from '../../../../layout/home/services/left-panel.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../core/security/user.service';
import { AbstractFormWidgetComponent } from '../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { InventoryReplenishActionService } from '../services/inventory-replenish-action.service';
import { InventoryReplenishDataService } from '../services/inventory-replenish-data.service';
import { DatePickerConfigService } from '../../../../shared/components/datepicker/datepicker-config.service';


@Component({
  selector: 'lfwms-inventory-replenish-accordian',
  templateUrl: './inventory-replenish-accordian.component.html',
  styleUrls: ['./inventory-replenish-accordian.component.css']
})
export class InventoryReplenishAccordianComponent extends AbstractFormWidgetComponent implements OnInit {

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    public actionService: InventoryReplenishActionService,
    public dataService: InventoryReplenishDataService,
    protected dateConfigService: DatePickerConfigService) {
    super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
  }

  public onChangeofFacility(facility) {
    this.actionService.onFacitityChange(facility);
  }

  public onChangeStorer(storer) {
    this.actionService.onStorerChange(storer.cVal);
  }

  public onChangeOfType(type) {
    this.actionService.onTypeChange(type.cVal);
  }

  public ngOnInit() {
    //[LFWM-2439] To update the value of replenishment group value based on storer and faclity while giving storer or facility restriction
    super.ngOnInit();
    if(this.dataService.primaryDataMap['storerKey'].cVal) {
      this.actionService.onStorerChange(this.dataService.primaryDataMap['storerKey'].cVal);
    }
    if(this.dataService.primaryDataMap['facility'].cVal) {
      this.actionService.onFacitityChange(this.dataService.primaryDataMap['facility'].cVal);
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/inventory-replenish/inventory-replenish-accordian/inventory-replenish-accordian.component.ts